import { RootState } from '../store';

export const formsTableFiltersSelector = (state: RootState) => state.forms.formsTableFilters;
export const formsCurrentFolderSelector = (state: RootState) => state.forms.currentFolder;
